import './App.css';
import { Home } from './pages/home';
import { Benefits } from './pages/benefits';
import { Services } from './pages/services';
import { Footer, Header } from './components';
import { useEffect, useRef } from 'react';
import { setIsMobile } from "./store/slices/dataSlice";
import { useDispatch } from 'react-redux';

function App() {
  const dispatch = useDispatch();
  const refBenefits = useRef<HTMLDivElement>(null);
  const refServices = useRef<HTMLDivElement>(null);

  const selectSection = (section: string) => {
    if(section === 'benefits'){
      refBenefits.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if(section === 'services') {
      refServices.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  const handleResize = () => {
    dispatch(setIsMobile(window.innerWidth < 900))
  };
  
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="App">
      <Header onClickSection={selectSection}/>
      <Home/>
      <Benefits ref={refBenefits}/>
      <Services ref={refServices}/>
      <Footer />
    </div>
  );
}

export default App;
